import { NgModule, ElementRef, Injectable } from '@angular/core';

@Injectable()
export class LoggerService {
  log(msg: any) { console.log(msg); }
  error(msg: any) { console.error(msg); }
  warn(msg: any) { console.warn(msg); }
}



// WEBPACK FOOTER //
// ./src/app/core/service/logger.service.ts